import { HeaderContent } from '@/configs/header/header.config';
import { useAppContext } from '@/providers/app-provider/app-provider';

type HeaderContentContext = {
  headerContent: HeaderContent;
};

//TODO:
const useHeaderContent = (): HeaderContent => {
  const { headerContent } = useAppContext<HeaderContentContext>();

  if (!headerContent) {
    throw new Error('headerContent needs to be passed to the current page context!');
  }

  return headerContent;
};

export default useHeaderContent;
